import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section className="bg-night-panel" data-id="element-103" data-mp="1o3x1pk7r0m0y">
      <div className="mx-auto max-w-content px-6 py-16 text-center lg:py-20" data-id="element-104" data-mp="1o33tsfx1zqh8">
        <ShieldCheckIcon className="mx-auto h-12 w-12 text-gold-soft" aria-hidden="true" data-id="element-105" data-mp="222d9zfl9ekl7" />
        <h2 className="mt-5 font-display text-3xl font-semibold uppercase tracking-tight text-parchment sm:text-4xl" data-id="element-106" data-mp="1x4uzvlvi9zbm">
          Garantía 7 días — sin preguntas
        </h2>

        <div className="mx-auto mt-8 max-w-xl rounded-2xl border border-gold-soft/40 bg-night p-7 lg:p-8" data-id="element-107" data-mp="14gfnz87o7x4i">
          <p className="font-sans text-base text-parchment/80" data-id="element-108" data-mp="1j5lt1ct6whkb">
            Abrís los mapas. Los usás en tu lectura diaria o en tu grupo bíblico.
          </p>
          <p className="mt-4 font-sans text-base text-parchment/80" data-id="element-109" data-mp="qo9h6cqer2hq">
            Si en 7 días no es lo que esperabas:
          </p>
          <p className="mt-4 font-display text-3xl font-semibold text-gold-soft" data-id="element-110" data-mp="lo4zwkhoe3qg">
            devolución del 100%
          </p>
          <p className="mt-2 font-sans text-base font-semibold text-parchment" data-id="element-111" data-mp="oz02jss8lwn9">
            sin formularios, sin drama.
          </p>
        </div>

        <p className="mt-5 font-sans text-sm text-parchment/50" data-id="element-112" data-mp="ypkxn68pcj1f">
          Tasa de devoluciones: menos del 1%.
        </p>
      </div>
    </section>;
}